import { object } from "prop-types";
import { BaseComponent } from "./BaseComponent";
import { IFormElementContextWrapper } from "./Validation/IFormElementContextWrapper";
import { IValidatable } from "./Validation/IValidatable";
import { ObjectComparer } from "../Utils/ObjectComparer";
import { isNullOrEmpty } from "../Utils/Arrays";

export interface IBaseFormElementProps {
    onValidationResultChange?: (isValid: boolean, validationErrors: string[], showValidationMessages?: boolean) => void;
}

export abstract class BaseFormElement<TProps extends IBaseFormElementProps, TState>
    extends BaseComponent<TProps, TState>
    implements IValidatable {
    public static contextTypes: React.ValidationMap<any> = {
        formElement: object.isRequired,
    };

    public context: IFormElementContextWrapper;

    private _lastValidationErrors: string[] = [];

    constructor(props: TProps) {
        super(props);
    }

    public abstract isValid(): boolean;

    public abstract setDisable(): void;

    public componentWillMount(): void {
        super.UNSAFE_componentWillMount();

        if (this.context && this.context.formElement && this.context.formElement.attachToForm) {
            this.context.formElement.attachToForm(this);
        }
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();

        if (this.context && this.context.formElement && this.context.formElement.detachFromForm) {
            this.context.formElement.detachFromForm(this);
        }
    }

    protected triggerValidationResultChange(validationErrors: string[], validationTriggered?: boolean): void {
        if (!this.props.onValidationResultChange) {
            return;
        }

        if (!validationTriggered && !ObjectComparer.arraysDiffer(this._lastValidationErrors, validationErrors)) {
            return;
        }

        this._lastValidationErrors = validationErrors;
        const isValid = isNullOrEmpty(validationErrors);
        this.props.onValidationResultChange(isValid, validationErrors, validationTriggered);
    }
}
